import { Outside } from '@cian/ui-kit/services';
import React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function BottomBannerLayout(_ref) {
  var closeBanner = _ref.closeBanner,
    open = _ref.open,
    children = _ref.children,
    contentClassName = _ref.contentClassName;
  React.useEffect(function () {
    document.documentElement.classList.add(styles['disabled-scroll']);
    document.body.classList.add(styles['disabled-scroll']);
    return function () {
      document.documentElement.classList.remove(styles['disabled-scroll']);
      document.body.classList.remove(styles['disabled-scroll']);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles['banner-wrapper'],
    children: /*#__PURE__*/_jsx(Outside, {
      onOutside: closeBanner,
      active: open,
      children: /*#__PURE__*/_jsx("div", {
        className: cn(styles['banner-content'], contentClassName),
        children: children
      })
    })
  });
}